import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "evBattery"
const EvBatteryIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M13.313 10.313H16.916L9.188 20.359V13.687H5.584L13.313 3.642zM7.869 12.563H10.313V17.05L14.63 11.438H12.188V6.948z"
            clipRule="evenodd"
          />
          <path d="M8.97 7.5H3.75V16.5H7.875V18H3.75C2.922 18 2.25 17.328 2.25 16.5V7.5C2.25 6.672 2.922 6 3.75 6H10.068zM19.125 6C19.953 6 20.625 6.672 20.625 7.5V9.05C21.272 9.215 21.75 9.8 21.75 10.5V13.5C21.75 14.199 21.272 14.784 20.625 14.95V16.5C20.625 17.328 19.953 18 19.125 18H12.371L13.456 16.5H19.125V13.5H20.25V10.5H19.125V7.5H14.625V6z" />
        </svg>
      }
    </span>
  )
}
export default EvBatteryIcon
